import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import '../style/page.css'


function Unauthorized() {
    const navigate = useNavigate()
    return (
        <div className='notFound'>
            <Result
                status="403"
                title="403"
                subTitle="Sorry, you are not authorized to access this page."
                extra={<Button type="primary" onClick={()=>navigate(-1)}>Go Back</Button>}
            />

        </div>
    )
}

export default Unauthorized